import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext.js';
import ProtectedRoute from './components/ProtectedRoute.js';
import LoginPage from './pages/LoginPage.js';
import RecordPage from './pages/RecordPage';
import ListPage from './pages/ListPage';
import DetailPage from './pages/DetailPage';
import SettingsPage from './pages/SettingsPage';
import UploadPage from './pages/UploadPage';
import CloudFlareUploadPage from './pages/CloudFlareUploadPage';
import RecordTestPage from './pages/RecordTestPage';
import RecordTestPageNew from './pages/RecordTestPageNew';
import RecordTestPageNewFixed from './pages/RecordTestPageNewFixed';
import RecordingPage from './pages/RecordingPage';

// 主页重定向组件
function RecordingPageRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/recording', { replace: true });
  }, [navigate]);

  return null;
}

function AppWithDragDrop() {
  const navigate = useNavigate();
  const location = useLocation();

  // 文件拖拽处理
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // 如果当前在upload页面，不处理拖拽事件，让页面内部处理
    if (location.pathname === '/upload') {
      return;
    }

    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      // 验证文件类型
      const validTypes = ['audio/mp3', 'audio/mpeg', 'audio/wav', 'audio/x-wav', 'audio/mp4', 'audio/m4a', 'audio/ogg', 'audio/flac', 'audio/webm', 'video/webm'];

      if (!validTypes.includes(file.type) && !file.name.match(/\.(mp3|wav|m4a|ogg|flac|webm)$/i)) {
        alert('不支持的文件类型，请选择音频文件');
        return;
      }

      
      // 将文件存储到 sessionStorage 并跳转到上传页面
      const reader = new FileReader();
      reader.onload = (e) => {
        const fileData = {
          name: file.name,
          size: file.size,
          type: file.type,
          dataUrl: e.target.result
        };

        sessionStorage.setItem('uploadFile', JSON.stringify(fileData));
        // 设置标记，表示这是从其他页面拖入的文件
        sessionStorage.setItem('uploadFileFromDrag', 'true');
        navigate('/upload');
      };

      reader.readAsDataURL(file);
    }
  };

  return (
    <div
      className="min-h-screen bg-black"
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={
          <ProtectedRoute>
            <RecordingPageRedirect />
          </ProtectedRoute>
        } />
        <Route path="/recording" element={
          <ProtectedRoute>
            <RecordingPage />
          </ProtectedRoute>
        } />
        <Route path="/recording/:audioId" element={
          <ProtectedRoute>
            <RecordingPage />
          </ProtectedRoute>
        } />
        <Route path="/records" element={
          <ProtectedRoute>
            <ListPage />
          </ProtectedRoute>
        } />
        <Route path="/record/:id" element={
          <ProtectedRoute>
            <DetailPage />
          </ProtectedRoute>
        } />
        <Route path="/settings" element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        } />
        <Route path="/upload" element={
          <ProtectedRoute>
            <UploadPage />
          </ProtectedRoute>
        } />
        <Route path="/cloudflare-upload" element={<CloudFlareUploadPage />} />
        <Route path="/record-test" element={<RecordTestPageNew />} />
        <Route path="/record-test/:sessionId" element={<RecordTestPageNew />} />
        <Route path="/record-test-new" element={<RecordTestPageNewFixed />} />
        <Route path="/record-test-new/:sessionId" element={<RecordTestPageNewFixed />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppWithDragDrop />
      </Router>
    </AuthProvider>
  );
}

export default App;